export class Notification {
    title: string;
    message: string;
}

export const networkNotification: Notification = {
    title: 'Network Error',
    message: 'Sorry, there was a problem reaching the server. Check your network connection or try again later.',
};

export const serverNotification: Notification = {
    title: 'Server Error',
    message: 'Sorry, there was a problem on the server. Please try again later.',
};

export const notFoundNotification: Notification = {
    title: 'Not Found',
    message: 'Sorry, this item was not found.',
};

export const clientNotification: Notification = {
    title: 'Client Error',
    message: 'Sorry, there was a problem with the request.',
};

export const unknownErrorNotification: Notification = {
    title: 'Unknown Error',
    message: 'Sorry, there was a problem. Please try again later.',
};



// WEBPACK FOOTER //
// D:/a/1/s/src/app/entities/notification.ts